<script setup lang="ts">
import styles from '@/components/loaders/SimpleLoader.module.scss';
import SimpleLoader from '@/components/loaders/SimpleLoader.vue';

export interface Props {
  color?: string;
  bgColor?: string;
  size?: number;
  width?: number;
  indeterminate?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  color: styles.noticesProgressColor,
  bgColor: styles.bgColor,
  size: 60,
  width: 4,
  indeterminate: true,
});
</script>

<template>
  <SimpleLoader
    :class="$style.wrapperBackground"
    :color="props.color"
    :bg-color="props.bgColor"
    :size="props.size"
    :width="props.width"
    :indeterminate="props.indeterminate"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.wrapperBackground {
  background-color: colors.$color-gray-50;
}
</style>
